<script setup lang="ts">
defineOptions( {
  inheritAttrs: false,
} );

const { carouselRef, orientation } = useCarousel();
</script>

<template>
  <div
    ref="carouselRef"
    class="carousel-content"
    :class="{
      'carousel-content--horizontal': orientation === 'horizontal',
      'carousel-content--vertical': orientation === 'vertical',
    }">
    <div
      class="carousel-content__inner"
      v-bind="$attrs">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.carousel-content {
  overflow: hidden;
  margin-block: -1rem;
  padding-block: 1rem;

  &__inner {
    display: flex;
  }

  &--horizontal {
    margin-left: -1rem;
  }

  &--vertical {
    margin-top: -1rem;
    flex-direction: column;
  }
}
</style>
